import type { IOrderMSNote } from './../types/note/models'
import { makeNoteService } from '~/cynqueModules/factoriesForServices/notes'

export const {
  createNote: createOrderMSNote,
  updateNote: updateOrderMSNote,
  deleteNote: deleteOrderMSNote,
} = makeNoteService<IOrderMSNote>('/api/ordermsnotes', 'orderMSNote')
